import { gql } from '@apollo/client'

export const UPDATE_MEDICAL_HISTORY = gql`
  mutation UPDATE_MEDICAL_HISTORY($patient: ID!, $medicalValues: [MedicalValuesInput!]!) {
    updateMedicalHistory(patient: $patient, medicalValues: $medicalValues) {
      id
      hasMedicalAlerts
      medicalUpdater {
        id
        name
      }
      medicalUpdatedAt
      signed
      witnessSigned
      medicalHistory {
        id
        status
        details
        options
        checkboxes
        medicalItemId
      }
    }
  }
`
export const UPDATE_CLINICAL_TEST = gql`
  mutation UPDATE_CLINICAL_TEST(
    $generatedID: ID!
    $patient: ID
    $clinicalTest: ID
    $description: String
    $clinicalValues: [MedicalValuesInput!]!
  ) {
    updateClinicalTest(
      generatedID: $generatedID
      patient: $patient
      clinicalTest: $clinicalTest
      description: $description
      clinicalValues: $clinicalValues
    ) {
      id
      description
      signed
      witnessSigned
      values {
        id
        status
        details
        options
        checkboxes
        clinicalItem {
          type
          id
        }
      }
      createdBy {
        id
        name
      }
      updatedBy {
        id
        name
      }
      createdAt
      updatedAt
    }
  }
`
export const ADD_NEW_PATIENT = gql`
  mutation ADD_NEW_PATIENT(
    $generatedID: ID!
    $branch: ID!
    $firstName: String!
    $lastName: String!
    $address: String
    $email: String
    $birthDate: DateTime
    $birthDay: String
    $patientDetails: String
    $gender: String
    $marital: String
    $nationalId: String
    $nationality: String
    $patientTitle: String
    $assignedPractitioner: ID
    $patientId: String
    $referenceId: Float
    $phoneNumber: String!
    $phoneNumber2: String!
    $firstNameE: String
    $lastNameE: String
    $phoneNumberE: String
    $phoneNumber2E: String
    $referralDetails: String
    $addressE: String
    $relationE: String
    $country: String
    $state: String
    $longitude: Float
    $latitude: Float
    $insurance: ID
    $insuranceLimit: Float
    $insurancePercentage: Float
    $insuranceEndDate: DateTime
    $insuranceStartMonth: Int
    $insuranceUnlimited: Boolean
    $approvalRequired: Boolean
    $isTempPatient: Boolean
    $priceList: ID
    $sms: Boolean
    $customFields: [CustomFieldInput!]!
    $patientTags: [ID]
    $referralSource: ID
    $referralSubSource: ID
    $referralUser: ID
    $referralPatient: ID
    $createdAt: DateTime
    $job: String
    $images: [String]
    $tax: Float
    $insuranceNumber: String
    $insuranceGroup: String
    $insuranceCRT: String
    $family: [PatientFamilyInput]
    $conversation: ID
    $lead: ID
    $insurancePolicy: ID
    $maxInsuranceLimit: Float
    $identifierType: String
    $policyClass: ID
  ) {
    addNewPatient(
      generatedID: $generatedID
      branch: $branch
      firstName: $firstName
      lastName: $lastName
      address: $address
      email: $email
      birthDate: $birthDate
      birthDay: $birthDay
      patientDetails: $patientDetails
      gender: $gender
      marital: $marital
      nationalId: $nationalId
      nationality: $nationality
      patientTitle: $patientTitle
      assignedPractitioner: $assignedPractitioner
      patientId: $patientId
      referenceId: $referenceId
      phoneNumber: $phoneNumber
      phoneNumber2: $phoneNumber2
      firstNameE: $firstNameE
      lastNameE: $lastNameE
      phoneNumberE: $phoneNumberE
      phoneNumber2E: $phoneNumber2E
      referralDetails: $referralDetails
      addressE: $addressE
      relationE: $relationE
      country: $country
      state: $state
      longitude: $longitude
      latitude: $latitude
      insurance: $insurance
      insuranceLimit: $insuranceLimit
      insurancePercentage: $insurancePercentage
      insuranceEndDate: $insuranceEndDate
      insuranceStartMonth: $insuranceStartMonth
      insuranceUnlimited: $insuranceUnlimited
      approvalRequired: $approvalRequired
      isTempPatient: $isTempPatient
      priceList: $priceList
      sms: $sms
      customFields: $customFields
      patientTags: $patientTags
      referralSource: $referralSource
      referralSubSource: $referralSubSource
      referralUser: $referralUser
      referralPatient: $referralPatient
      createdAt: $createdAt
      job: $job
      images: $images
      tax: $tax
      insuranceNumber: $insuranceNumber
      insuranceGroup: $insuranceGroup
      insuranceCRT: $insuranceCRT
      family: $family
      conversation: $conversation
      lead: $lead
      insurancePolicy: $insurancePolicy
      maxInsuranceLimit: $maxInsuranceLimit
      identifierType: $identifierType
      policyClass: $policyClass
    ) {
      id
      firstName
      lastName
      patientId
      referenceId
      phoneNumber
      country
      hasValidNumber
      gender
      marital
      nationalId
      nationality
      email
      insuranceCompany {
        id
        name
      }
      insured
      insuranceLimit
      insuranceUnlimited
      insurancePercentage
      insuranceEndDate
      insuranceStartMonth
      approvalRequired
      details
      phoneNumber
      firstNameE
      lastNameE
      phoneNumberE
      phoneNumber2E
      referralDetails
      addressE
      relationE
      address
      title
      birthDate
      birthDay
      job
      patientTags {
        id
        name
        color
        hasNextTags
      }
      referralSource {
        id
        name
        color
      }
      referralSubSource {
        id
        name
        color
      }
      images
      tax
      insuranceNumber
      insuranceGroup
      insuranceCRT
      doctor {
        id
        name
      }
      priceList {
        id
        name
      }
      createdAt
      updatedAt
      createdBy {
        id
        name
      }
      updatedBy {
        id
        name
      }
      customFields {
        id
        value
        field {
          id
        }
      }
    }
  }
`
export const EDIT_PATIENT = gql`
  mutation EDIT_PATIENT(
    $patient: ID!
    $firstName: String!
    $lastName: String!
    $address: String
    $email: String
    $birthDate: DateTime
    $birthDay: String
    $patientDetails: String
    $gender: String
    $marital: String
    $nationalId: String
    $nationality: String
    $patientTitle: String
    $assignedPractitioner: ID
    $patientId: String
    $phoneNumber: String!
    $phoneNumber2: String
    $firstNameE: String
    $lastNameE: String
    $phoneNumberE: String
    $phoneNumber2E: String
    $referralDetails: String
    $addressE: String
    $relationE: String
    $insurance: ID
    $insuranceLimit: Float
    $insurancePercentage: Float
    $insuranceEndDate: DateTime
    $insuranceStartMonth: Int
    $insuranceUnlimited: Boolean
    $approvalRequired: Boolean
    $priceList: ID
    $customFields: [CustomFieldInput!]
    $patientTags: [ID]
    $referralSource: ID
    $referralSubSource: ID
    $referralUser: ID
    $referralPatient: ID
    $country: String
    $state: String
    $longitude: Float
    $latitude: Float
    $createdAt: DateTime
    $job: String
    $images: [String]
    $tax: Float
    $insuranceNumber: String
    $insuranceGroup: String
    $insuranceCRT: String
    $branch: ID!
    $family: [PatientFamilyInput]
    $insurancePolicy: ID
    $maxInsuranceLimit: Float
    $identifierType: String
    $policyClass: ID
    $assignNewID: Boolean
  ) {
    editPatient(
      patient: $patient
      firstName: $firstName
      lastName: $lastName
      address: $address
      email: $email
      birthDate: $birthDate
      birthDay: $birthDay
      patientDetails: $patientDetails
      gender: $gender
      marital: $marital
      nationalId: $nationalId
      nationality: $nationality
      patientTitle: $patientTitle
      assignedPractitioner: $assignedPractitioner
      patientId: $patientId
      phoneNumber: $phoneNumber
      phoneNumber2: $phoneNumber2
      firstNameE: $firstNameE
      lastNameE: $lastNameE
      phoneNumberE: $phoneNumberE
      phoneNumber2E: $phoneNumber2E
      referralDetails: $referralDetails
      addressE: $addressE
      relationE: $relationE
      insurance: $insurance
      insuranceLimit: $insuranceLimit
      insurancePercentage: $insurancePercentage
      insuranceEndDate: $insuranceEndDate
      insuranceStartMonth: $insuranceStartMonth
      insuranceUnlimited: $insuranceUnlimited
      approvalRequired: $approvalRequired
      priceList: $priceList
      customFields: $customFields
      patientTags: $patientTags
      referralSource: $referralSource
      referralSubSource: $referralSubSource
      referralUser: $referralUser
      referralPatient: $referralPatient
      country: $country
      state: $state
      longitude: $longitude
      latitude: $latitude
      createdAt: $createdAt
      job: $job
      images: $images
      tax: $tax
      insuranceNumber: $insuranceNumber
      insuranceGroup: $insuranceGroup
      insuranceCRT: $insuranceCRT
      branch: $branch
      family: $family
      insurancePolicy: $insurancePolicy
      maxInsuranceLimit: $maxInsuranceLimit
      identifierType: $identifierType
      policyClass: $policyClass
      assignNewID: $assignNewID
    ) {
      id
      firstName
      lastName
      patientId
      referenceId
      phoneNumber
      hasValidNumber
      gender
      marital
      nationalId
      nationality
      email
      type
      insuranceCompany {
        id
        name
      }
      primaryFamily {
        id
        relation
        secondary {
          id
          firstName
          lastName
        }
      }
      insured
      insuranceLimit
      insuranceUnlimited
      approvalRequired
      insurancePercentage
      insuranceEndDate
      insuranceStartMonth
      details
      phoneNumber2
      country
      longitude
      latitude
      firstNameE
      lastNameE
      phoneNumberE
      phoneNumber2E
      referralDetails
      addressE
      relationE
      address
      title
      birthDate
      birthDay
      job
      patientTags {
        id
        name
        color
        hasNextTags
      }
      referralSource {
        id
        name
        color
      }
      referralSubSource {
        id
        name
        color
      }
      images
      tax
      insuranceNumber
      insuranceGroup
      insuranceCRT
      doctor {
        id
        name
      }
      priceList {
        id
        name
      }
      createdAt
      updatedAt
      createdBy {
        id
        name
      }
      updatedBy {
        id
        name
      }
      customFields {
        id
        value
        field {
          id
        }
      }
      referralUser {
        id
        name
      }
      branch {
        id
        name
      }
      referralPatient {
        id
        firstName
        lastName
      }
      identifierType
      maxInsuranceLimit
      insurancePolicy {
        id
        holderName
      }
      policyClass {
        id
        name
        maxLimit
        insuranceLimit
        insuranceUnlimited
        insurancePercentage
        approvalRequired
      }
      currentEligibility {
        id
        status
        checkedAt
        responseDate
        insuranceCompanyId
      }
    }
  }
`
export const SEND_SMS = gql`
  mutation SEND_SMS(
    $to: String
    $body: String!
    $rawBody: [String]
    $parent: ID
    $doctor: ID
    $userId: ID
    $patients: [ID]
    $searchTerm: String
    $disabled: Boolean
    $rangeDate: [DateTime!]
    $insuranceCompanies: [ID]
    $insurancePolicy: ID
    $priceList: ID
    $branchId: ID
    $filters: Filter
    $type: String
    $appointment: ID
    $assignedToId: ID
    $id: ID
    $pendingPayment: Boolean
    $showUpdatedInvoices: Boolean
    $patient: ID
    $types: [CommunicationTypes!]!
    $patientLink: ID
    $message: ID
    $lead: ID
    $leadStage: ID
    $rejectReason: ID
    $initialView: ID
    $leadLink: ID
    $referralSource: ID
    $referralSubSource: ID
    $patientTags: [ID]
    $policyClass: ID
  ) {
    sendMessage(
      to: $to
      body: $body
      rawBody: $rawBody
      parent: $parent
      doctor: $doctor
      userId: $userId
      patients: $patients
      branchId: $branchId
      searchTerm: $searchTerm
      disabled: $disabled
      rangeDate: $rangeDate
      insuranceCompanies: $insuranceCompanies
      insurancePolicy: $insurancePolicy
      priceList: $priceList
      filters: $filters
      type: $type
      appointment: $appointment
      assignedToId: $assignedToId
      id: $id
      pendingPayment: $pendingPayment
      showUpdatedInvoices: $showUpdatedInvoices
      patient: $patient
      types: $types
      patientLink: $patientLink
      message: $message
      lead: $lead
      leadStage: $leadStage
      rejectReason: $rejectReason
      initialView: $initialView
      leadLink: $leadLink
      referralSource: $referralSource
      referralSubSource: $referralSubSource
      patientTags: $patientTags
      policyClass: $policyClass
    ) {
      id
      messagesLeft
    }
  }
`

export const UPDATE_PATIENTS_TAGS = gql`
  mutation UPDATE_PATIENTS_TAGS(
    $newPatientTags: [ID!]!
    $patients: [ID]
    $doctor: ID
    $searchTerm: String
    $disabled: Boolean
    $rangeDate: [DateTime!]
    $insuranceCompanies: [ID]
    $insurancePolicy: ID
    $priceList: ID
    $branchId: ID
    $filters: Filter
    $patientLink: ID
    $policyClass: ID
    $userId: ID
  ) {
    updatePatientsTags(
      newPatientTags: $newPatientTags
      patients: $patients
      doctor: $doctor
      branchId: $branchId
      searchTerm: $searchTerm
      disabled: $disabled
      rangeDate: $rangeDate
      insuranceCompanies: $insuranceCompanies
      insurancePolicy: $insurancePolicy
      priceList: $priceList
      filters: $filters
      patientLink: $patientLink
      policyClass: $policyClass
      userId: $userId
    )
  }
`

export const UPDATE_PATIENT_TAGS = gql`
  mutation UPDATE_PATIENT_TAGS($newPatientTags: [ID!]!, $patient: ID!) {
    updatePatientTags(newPatientTags: $newPatientTags, patient: $patient) {
      id
      patientTags {
        id
        name
        color
        icon
        hasNextTags
      }
    }
  }
`
export const ADD_NEW_PATIENT_REMINDER = gql`
  mutation ADD_NEW_PATIENT_REMINDER(
    $name: String!
    $every: Int!
    $interval: String!
    $procedures: [ID!]!
    $procedureSteps: [ID!]!
    $automatic: Boolean
    $details: String
    $info: String
    $at: Int
    $branch: ID
    $types: [CommunicationTypes!]!
    $whatsAppTemplate: JSON
  ) {
    addNewPatientReminder(
      name: $name
      every: $every
      interval: $interval
      procedures: $procedures
      procedureSteps: $procedureSteps
      automatic: $automatic
      details: $details
      info: $info
      at: $at
      branch: $branch
      types: $types
      whatsAppTemplate: $whatsAppTemplate
    ) {
      id
      name
      every
      interval
      automatic
      at
      details
      whatsAppTemplate
      info
      types
      procedures {
        id
        name
        code
        group {
          id
          name
        }
      }
      procedureSteps {
        id
        name
        procedure {
          id
          name
          code
          group {
            id
            name
          }
        }
      }
      branch {
        id
        name
      }
      createdBy {
        id
        name
      }
      updatedBy {
        id
        name
      }
      createdAt
      updatedAt
    }
  }
`
export const EDIT_PATIENT_REMINDER = gql`
  mutation EDIT_PATIENT_REMINDER(
    $patientReminder: ID!
    $name: String!
    $every: Int!
    $interval: String!
    $procedures: [ID!]!
    $procedureSteps: [ID!]!
    $automatic: Boolean
    $details: String
    $info: String
    $at: Int
    $branch: ID
    $types: [CommunicationTypes!]!
    $components: String
    $whatsAppTemplate: JSON
  ) {
    editPatientReminder(
      patientReminder: $patientReminder
      name: $name
      every: $every
      interval: $interval
      procedures: $procedures
      procedureSteps: $procedureSteps
      automatic: $automatic
      details: $details
      info: $info
      at: $at
      branch: $branch
      types: $types
      components: $components
      whatsAppTemplate: $whatsAppTemplate
    ) {
      id
      name
      every
      interval
      automatic
      at
      details
      whatsAppTemplate
      info
      types
      procedures {
        id
        name
        code
        group {
          id
          name
        }
      }
      procedureSteps {
        id
        name
        procedure {
          id
          name
          code
          group {
            id
            name
          }
        }
      }
      branch {
        id
        name
      }
      createdBy {
        id
        name
      }
      updatedBy {
        id
        name
      }
      createdAt
      updatedAt
    }
  }
`
export const DELETE_PATIENT_REMINDER = gql`
  mutation DELETE_PATIENT_REMINDER($patientReminder: ID!) {
    deletePatientReminder(patientReminder: $patientReminder) {
      id
    }
  }
`
export const MARK_REMINDED = gql`
  mutation MARK_REMINDED($reminderInstance: ID!) {
    markReminded(reminderInstance: $reminderInstance) {
      id
      remindedAt
      createdBy {
        id
        name
      }
    }
  }
`
export const ADD_NEW_PATIENT_FILE = gql`
  mutation ADD_NEW_PATIENT_FILE(
    $forUser: Boolean
    $patient: ID
    $insuranceCompany: ID
    $supplier: ID
    $lab: ID
    $invoice: ID
    $expense: ID
    $income: ID
    $name: String!
    $url: String!
    $size: Float!
    $type: String!
    $order: Int
    $xray: ID
    $treasury: ID
    $counter: ID
    $inventoryItem: ID
    $inventoryOrder: ID
    $folder: ID
    $operation: ID
  ) {
    addNewPatientFile(
      forUser: $forUser
      patient: $patient
      insuranceCompany: $insuranceCompany
      supplier: $supplier
      lab: $lab
      invoice: $invoice
      expense: $expense
      income: $income
      name: $name
      url: $url
      size: $size
      type: $type
      order: $order
      xray: $xray
      treasury: $treasury
      counter: $counter
      inventoryItem: $inventoryItem
      inventoryOrder: $inventoryOrder
      folder: $folder
      operation: $operation
    ) {
      id
      name
      url
      size
      type
      order
      createdBy {
        id
        name
      }
      updatedBy {
        id
        name
      }
      createdAt
      updatedAt
    }
  }
`
export const EDIT_PATIENT_FILE = gql`
  mutation EDIT_PATIENT_FILE($file: ID!, $name: String!) {
    editPatientFile(file: $file, name: $name) {
      id
      name
      url
      size
      type
      order
      createdBy {
        id
        name
      }
      updatedBy {
        id
        name
      }
      createdAt
      updatedAt
    }
  }
`
export const DELETE_PATIENT_FILE = gql`
  mutation DELETE_PATIENT_FILE($file: ID!) {
    deletePatientFile(file: $file) {
      id
    }
  }
`
export const ADD_NEW_FOLDER = gql`
  mutation ADD_NEW_FOLDER($name: String!, $parent: ID, $patient: ID!) {
    addNewFolder(name: $name, parent: $parent, patient: $patient) {
      id
      name
      createdBy {
        id
        name
      }
      updatedBy {
        id
        name
      }
      createdAt
      updatedAt
    }
  }
`
export const EDIT_FOLDER = gql`
  mutation EDIT_FOLDER($folder: ID!, $name: String!) {
    editFolder(folder: $folder, name: $name) {
      id
      name
      createdBy {
        id
        name
      }
      updatedBy {
        id
        name
      }
      createdAt
      updatedAt
    }
  }
`
export const DELETE_FOLDER = gql`
  mutation DELETE_FOLDER($folder: ID!) {
    deleteFolder(folder: $folder) {
      id
    }
  }
`
export const MOVE_FILE_TO_FOLDER = gql`
  mutation MOVE_FILE_TO_FOLDER($file: ID!, $folder: ID) {
    moveFileToFolder(file: $file, folder: $folder) {
      id
      folder {
        id
        name
      }
    }
  }
`
export const MOVE_FOLDER_TO_FOLDER = gql`
  mutation MOVE_FOLDER_TO_FOLDER($folder: ID!, $parent: ID) {
    moveFolderToFolder(folder: $folder, parent: $parent) {
      id
      parent {
        id
        name
      }
    }
  }
`
export const ADD_NEW_PATIENT_XRAY = gql`
  mutation ADD_NEW_PATIENT_XRAY(
    $patient: ID!
    $name: String
    $details: String
    $type: String!
    $appointment: ID
    $operation: ID
    $files: [ID!]!
  ) {
    addNewPatientXray(
      patient: $patient
      name: $name
      details: $details
      type: $type
      appointment: $appointment
      files: $files
      operation: $operation
    ) {
      id
      name
      details
      appointment {
        id
        start
        status
      }
      type
      files {
        id
        name
        url
        order
      }
      createdBy {
        id
        name
      }
      updatedBy {
        id
        name
      }
      createdAt
      updatedAt
    }
  }
`
export const EDIT_PATIENT_XRAY = gql`
  mutation EDIT_PATIENT_XRAY($xray: ID!, $name: String, $details: String, $type: String!, $appointment: ID) {
    editPatientXray(xray: $xray, name: $name, details: $details, type: $type, appointment: $appointment) {
      id
      name
      details
      appointment {
        id
        start
        status
      }
      type
      files {
        id
        name
        url
        order
      }
      createdBy {
        id
        name
      }
      updatedBy {
        id
        name
      }
      createdAt
      updatedAt
    }
  }
`
export const DELETE_PATIENT_XRAY = gql`
  mutation DELETE_PATIENT_XRAY($xray: ID!) {
    deletePatientXray(xray: $xray) {
      id
    }
  }
`
export const UPDATE_OPERATIONS_STATUS = gql`
  mutation UPDATE_OPERATIONS_STATUS(
    $status: OperationStatusType
    $operations: [ID!]!
    $appointment: ID
    $approved: Boolean
    $createdAt: DateTime
    $doctor: ID
    $sms: Boolean
    $createItems: Boolean
    $preAuth: String
    $insuranceValue: Float
    $counters: [OperationCounterInput!]
  ) {
    updateOperationsStatus(
      status: $status
      operations: $operations
      appointment: $appointment
      approved: $approved
      createdAt: $createdAt
      doctor: $doctor
      sms: $sms
      createItems: $createItems
      preAuth: $preAuth
      insuranceValue: $insuranceValue
      counters: $counters
    ) {
      id
      start
      end
      status
      approved
      tooth
      preAuth
      actionsCreated
      insuranceValue
      labOrders {
        id
        name
        createdAt
      }
      formInstances {
        id
        name
        createdAt
      }
      prescriptions {
        id
        name
        createdAt
      }
      procedure {
        id
        openLab
      }
      patient {
        id
      }
      appointment {
        id
        start
        status
        createdBy {
          id
          name
        }
      }
      inventoryTransactions {
        id
        inventoryOrderId
        amount
        operationId
        operationStepId
        patientId
        appointmentId
        inventoryItem {
          id
          name
          images
          defaultSubItem {
            id
            name
            price
            box
            images
          }
        }
      }
      steps {
        id
        name
        order
        status
      }
      updatedBy {
        id
        name
      }
      doctor {
        id
        name
      }
      updatedAt
      createdAt
    }
  }
`

export const UPDATE_OPERATION_STEP_STATUS = gql`
  mutation UPDATE_OPERATION_STEP_STATUS(
    $status: OperationStatusType
    $operationStep: ID!
    $appointment: ID
    $branch: ID!
    $sms: Boolean
    $createItems: Boolean
    $counter: ID
    $counterAmount: Int
  ) {
    updateOperationStepStatus(
      status: $status
      operationStep: $operationStep
      appointment: $appointment
      branch: $branch
      sms: $sms
      createItems: $createItems
      counter: $counter
      counterAmount: $counterAmount
    ) {
      id
      status
      order
      actionsCreated
      end
      counterLog {
        id
      }
      operation {
        id
        child
        tooth
        status
        invoice {
          id
          pendingPayment
          pendingPaymentPercent
        }
        labOrders {
          id
          name
          createdAt
        }
        formInstances {
          id
          name
          createdAt
        }
        prescriptions {
          id
          name
          createdAt
        }
      }
      labOrders {
        id
        name
        createdAt
      }
      formInstances {
        id
        name
        createdAt
      }
      prescriptions {
        id
        name
        createdAt
      }
      procedureStep {
        id
        openLab
      }
      patient {
        id
      }
      appointment {
        id
        start
        status
        createdBy {
          id
          name
        }
      }
      inventoryTransactions {
        id
        inventoryOrderId
        amount
        operationId
        operationStepId
        patientId
        appointmentId
        inventoryItem {
          id
          name
          images
          defaultSubItem {
            id
            name
            price
            box
            images
          }
        }
      }
      updatedBy {
        id
        name
      }
      doctor {
        id
        name
      }
      updatedAt
      createdAt
    }
  }
`
export const SAVE_OPERATIONS = gql`
  mutation SAVE_OPERATIONS($operations: [EditOperationsInput]) {
    saveOperations(operations: $operations) {
      id
      price
      amount
      forOperator
      initialDiscount
      remaining
      priceDiff
      updatedBy {
        id
        name
      }
      updatedAt
    }
  }
`
export const EDIT_OPERATION = gql`
  mutation EDIT_OPERATION($operation: ID!, $details: String, $diagnosis: String) {
    editOperation(operation: $operation, details: $details, diagnosis: $diagnosis) {
      id
      details
      diagnosis
    }
  }
`
export const EDIT_OPERATION_WITHOUT_INVOICE = gql`
  mutation EDIT_OPERATION_WITHOUT_INVOICE(
    $operation: ID!
    $details: String
    $cost: Float!
    $tooth: [Int!]!
    $appointment: ID
    $doctor: ID
    $branch: ID!
    $forOperator: Float!
    $createdAt: DateTime
    $child: Boolean!
    $status: OperationStatusType
    $expires: DateTime
    $start: DateTime
    $end: DateTime
    $preAuth: String
  ) {
    editOperationWithoutInvoice(
      operation: $operation
      details: $details
      cost: $cost
      tooth: $tooth
      appointment: $appointment
      doctor: $doctor
      branch: $branch
      forOperator: $forOperator
      createdAt: $createdAt
      child: $child
      status: $status
      expires: $expires
      start: $start
      end: $end
      preAuth: $preAuth
    ) {
      id
      name
      code
      details
      cost
      status
      forOperator
      child
      expires
      start
      end
      preAuth
      procedure {
        id
        name
      }
      condition {
        id
        name
      }
      tooth
      appointment {
        id
        status
        start
      }
      doctor {
        id
        name
      }
      branch {
        id
        name
      }
      updatedBy {
        id
        name
      }
      createdAt
    }
  }
`

export const EDIT_OPERATION_STEP = gql`
  mutation EDIT_OPERATION_STEP(
    $operationStep: ID!
    $details: String
    $appointment: ID
    $doctor: ID
    $branch: ID!
    $forOperator: Float!
    $forLab: Float!
    $createdAt: DateTime
    $start: DateTime
    $end: DateTime
    $status: OperationStatusType
  ) {
    editOperationStep(
      operationStep: $operationStep
      details: $details
      appointment: $appointment
      doctor: $doctor
      branch: $branch
      forOperator: $forOperator
      forLab: $forLab
      createdAt: $createdAt
      start: $start
      end: $end
      status: $status
    ) {
      id
      details
      status
      forOperator
      forLab
      discount
      start
      end
      appointment {
        id
        status
        start
      }
      doctor {
        id
        name
      }
      branch {
        id
        name
      }
      updatedBy {
        id
        name
      }
      updatedAt
      createdAt
    }
  }
`

export const EDIT_OPERATION_STEP_DETAILS = gql`
  mutation EDIT_OPERATION_STEP_DETAILS($operationStep: ID!, $details: String) {
    editOperationStepDetails(operationStep: $operationStep, details: $details) {
      id
      details
      updatedAt
      updatedBy {
        id
        name
      }
    }
  }
`

export const EDIT_STEP_PAYMENT = gql`
  mutation EDIT_STEP_PAYMENT($paymentStep: ID!, $doctor: ID!, $branch: ID!, $forOperator: Float!) {
    editStepPayment(paymentStep: $paymentStep, doctor: $doctor, branch: $branch, forOperator: $forOperator) {
      id
      forOperator
      discount
      doctor {
        id
        name
      }
      branch {
        id
        name
      }
      updatedBy {
        id
        name
      }
    }
  }
`
export const DELETE_OPERATIONS = gql`
  mutation DELETE_OPERATIONS($operations: [ID!]!) {
    deleteOperations(operations: $operations)
  }
`
export const DELETE_OPERATION_STEP = gql`
  mutation DELETE_OPERATION_STEP($operationStep: ID!) {
    deleteOperationStep(operationStep: $operationStep) {
      id
    }
  }
`
export const CREATE_NEW_OPERATIONS = gql`
  mutation CREATE_NEW_OPERATIONS(
    $generatedID: String!
    $name: String
    $code: String
    $price: Float
    $cost: Float
    $status: OperationStatusType!
    $procedure: String
    $condition: String
    $tooth: [Int!]!
    $toothPart: [String]
    $appointment: String
    $patient: String!
    $doctor: String!
    $branch: String!
    $priceList: String
    $child: Boolean!
    $insuranceDiscount: Boolean
    $insuranceValue: Float
    $details: String
    $productPriceId: String
    $sms: Boolean
    $createItems: Boolean
    $counter: ID
    $counterAmount: Int
    $globalCondition: ID
    $manualPrice: Boolean
    $chart: ChartTypes
  ) {
    createNewOperations(
      generatedID: $generatedID
      name: $name
      code: $code
      price: $price
      cost: $cost
      status: $status
      procedure: $procedure
      condition: $condition
      tooth: $tooth
      toothPart: $toothPart
      appointment: $appointment
      patient: $patient
      doctor: $doctor
      branch: $branch
      priceList: $priceList
      child: $child
      insuranceDiscount: $insuranceDiscount
      insuranceValue: $insuranceValue
      details: $details
      productPriceId: $productPriceId
      sms: $sms
      createItems: $createItems
      counter: $counter
      counterAmount: $counterAmount
      globalCondition: $globalCondition
      manualPrice: $manualPrice
      chart: $chart
    ) {
      id
      amount
      tooth
      toothPart
      price
      cost
      forOperator
      child
      status
      approved
      approvalRequired
      insuranceDiscount
      diagnosis
      insuranceValue
      start
      end
      preAuth
      inventoryStatus
      priceDiff
      originalPrice
      details
      initialDiscount
      taxApplied
      discount
      tax
      actionsCreated
      name
      code
      missing
      remaining
      actionsCreated
      hasSteps
      expires
      preAuth
      allowMaxLimit
      dhsApproval {
        id
        status
        approvalNumber
        requestPayload
        responsePayload
        createdAt
        updatedAt
      }
      priceList {
        id
        name
        syncTo
      }
      procedure {
        id
        name
        code
        insuranceDiscount
        toothEffect
        ageGroup
        requireCounter
        requireOperationCounter
        remaining
        openLab
      }
      condition {
        id
        name
        code
        toothEffect
      }
      doctor {
        id
        name
      }
      labOrders {
        id
        name
        createdAt
      }
      formInstances {
        id
        name
        createdAt
      }
      prescriptions {
        id
        name
        createdAt
      }
      patient {
        id
        firstName
        lastName
        patientId
        referenceId
        phoneNumber
        insuranceLimit
        insurancePercentage
        insuranceEndDate
        insuranceUnlimited
        maxInsuranceLimit
        dailyInsurancePaid
        lastPaymentDate
        dailyAmountPaid
        approvalRequired
        policyClass {
          id
          name
          maxLimit
          insuranceLimit
          insuranceUnlimited
          insurancePercentage
          approvalRequired
        }
        insured
        tax
        insuranceCompany {
          id
          name
          number
        }
      }
      inventoryTransactions {
        id
        inventoryOrderId
        amount
        patientId
        appointmentId
        operationId
        operationStepId
        inventoryItem {
          id
          name
          images
          defaultSubItem {
            id
            name
            price
            box
            images
          }
        }
      }
      steps {
        id
        name
        status
        labOrders {
          id
          name
          createdAt
        }
        formInstances {
          id
          name
          createdAt
        }
        prescriptions {
          id
          name
          createdAt
        }
      }
      insuranceCompany {
        id
        name
      }
      appointment {
        id
        status
        urgent
        start
        end
        title
        details
        alert
        room
        diagnosticFee
        type
        createdAt
        diagnosticFeeInvoice {
          id
          diagnosticFee
        }
        createdBy {
          id
          name
        }
        doctor {
          id
          name
        }
      }
      quotations {
        id
      }
      branch {
        id
        name
        nphiesCode
      }
      files {
        id
        name
        url
        type
        size
      }
      createdAt
      updatedAt
      createdBy {
        id
        name
      }
      updatedBy {
        id
        name
      }
    }
  }
`
export const CREATE_NEW_INVOICE = gql`
  mutation CREATE_NEW_INVOICE(
    $generatedID: ID!
    $pendingPaymentPercent: Float!
    $operations: [ID!]!
    $patient: ID!
    $users: [ID]
    $markAppointmentsCompleted: Boolean
    $createdAt: DateTime
    $sms: Boolean
    $branch: ID!
    $doctor: ID!
    $invoiceId: String
    $details: String
    $referenceId: Float
    $treasury: ID
    $appointment: ID
    $lineItems: [InvoiceLineItem!]!
    $patientPartAlertShown: Boolean
    $preAuth: String
    $patientTaxPercent: Float
    $insuranceTaxPercent: Float
  ) {
    createNewInvoice(
      generatedID: $generatedID
      pendingPaymentPercent: $pendingPaymentPercent
      operations: $operations
      patient: $patient
      users: $users
      markAppointmentsCompleted: $markAppointmentsCompleted
      createdAt: $createdAt
      sms: $sms
      branch: $branch
      doctor: $doctor
      invoiceId: $invoiceId
      details: $details
      referenceId: $referenceId
      treasury: $treasury
      appointment: $appointment
      lineItems: $lineItems
      patientPartAlertShown: $patientPartAlertShown
      preAuth: $preAuth
      patientTaxPercent: $patientTaxPercent
      insuranceTaxPercent: $insuranceTaxPercent
    ) {
      id
      total
      tax
      diagnosticFee
      discount
      subtotal
      pendingPayment
      taxPercent
      discountPercent
      insurance
      pendingPaymentPercent
      patientPart
      invoiceId
      referenceId
      preAuth
      details
      operationInsurance
      operations {
        id
        amount
        tooth
        price
        child
        status
        approved
        approvalRequired
        toothPart
        invoice {
          id
          paid
          subtotal
          paidInFull
          pendingPayment
          discount
          tax
          invoiceId
          referenceId
          diagnosticFee
          insurance
          total
          taxPercent
          discountPercent
          pendingPaymentPercent
          balance
          details
        }
        procedure {
          id
          name
          code
          insuranceDiscount
          toothEffect
        }
        condition {
          id
          name
          code
          toothEffect
        }
        doctor {
          id
          name
        }
      }
      patient {
        id
        firstName
        lastName
        birthDate
        balance
        patientId
        referenceId
        phoneNumber
        insuranceCompany {
          id
          name
        }
        insuranceLimit
        insuranceNumber
        insuranceCRT
        insuranceGroup
        insurancePercentage
        insuranceEndDate
        insuranceUnlimited
        insured
        approvalRequired
        firstPaymentDate
        lastPaymentDate
        dailyAmountPaid
        insurancePaymentDate
        dailyInsurancePaid
        totalRemaining
        totalInsurance
        totalPaid
      }
      inventoryTransactions {
        id
        inventoryOrderId
        amount
        patientId
        appointmentId
        operationId
        operationStepId
        inventoryItem {
          id
          name
          images
          defaultSubItem {
            id
            name
            price
            box
            images
          }
        }
      }
      branch {
        id
        name
      }
      doctor {
        id
        name
      }
      users {
        id
        name
      }
      released
      releasedAt
      releasedBy {
        id
        name
      }
      createdAt
      updatedAt
      createdBy {
        id
        name
      }
      updatedBy {
        id
        name
      }
    }
  }
`
export const EDIT_INVOICE = gql`
  mutation EDIT_INVOICE(
    $invoice: ID!
    $pendingPaymentPercent: Float!
    $users: [ID]
    $createdAt: DateTime
    $branch: ID!
    $doctor: ID!
    $invoiceId: String
    $details: String
    $treasury: ID
    $lineItems: [InvoiceLineItem!]!
    $patientPartAlertShown: Boolean
    $preAuth: String
    $patientTaxPercent: Float
    $insuranceTaxPercent: Float
  ) {
    editInvoice(
      invoice: $invoice
      pendingPaymentPercent: $pendingPaymentPercent
      users: $users
      createdAt: $createdAt
      branch: $branch
      doctor: $doctor
      invoiceId: $invoiceId
      details: $details
      treasury: $treasury
      lineItems: $lineItems
      patientPartAlertShown: $patientPartAlertShown
      preAuth: $preAuth
      patientTaxPercent: $patientTaxPercent
      insuranceTaxPercent: $insuranceTaxPercent
    ) {
      id
      total
      tax
      diagnosticFee
      discount
      subtotal
      pendingPayment
      taxPercent
      discountPercent
      dfInsurance
      dfDiscount
      dfTax
      patientTaxPercent
      insuranceTaxPercent
      dfDiscountPercent
      dfInsurancePercent
      dfTaxApplied
      pendingPaymentPercent
      patientPart
      paid
      insurance
      invoiceId
      preAuth
      referenceId
      details
      operationInsurance
      patient {
        id
        firstName
        lastName
        birthDate
        balance
        patientId
        referenceId
        phoneNumber
        insuranceCompany {
          id
          name
        }
        insuranceLimit
        insurancePercentage
        insuranceEndDate
        insuranceUnlimited
        insured
        firstPaymentDate
        lastPaymentDate
        dailyAmountPaid
        insurancePaymentDate
        dailyInsurancePaid
        totalRemaining
        totalInsurance
        totalPaid
      }
      operations {
        id
        name
        code
        amount
        price
        status
        approved
        discount
        details
        tax
        discountPercent
        approvalRequired
        insuranceDiscount
        insuranceValue
        insurance
        taxApplied
      }
      branch {
        id
        name
      }
      doctor {
        id
        name
      }
      users {
        id
        name
      }
      released
      releasedAt
      releasedBy {
        id
        name
      }
      createdAt
      updatedAt
      createdBy {
        id
        name
      }
      updatedBy {
        id
        name
      }
    }
  }
`
export const EDIT_INVOICE_WITH_PAYMENTS = gql`
  mutation EDIT_INVOICE_WITH_PAYMENTS(
    $invoice: ID!
    $users: [ID]
    $createdAt: DateTime
    $branch: ID!
    $doctor: ID!
    $invoiceId: String
    $details: String
    $preAuth: String
  ) {
    editInvoiceWithPayments(
      invoice: $invoice
      users: $users
      createdAt: $createdAt
      branch: $branch
      doctor: $doctor
      invoiceId: $invoiceId
      details: $details
      preAuth: $preAuth
    ) {
      id
      invoiceId
      referenceId
      details
      preAuth
      users {
        id
        name
      }
      branch {
        id
        name
      }
      doctor {
        id
        name
      }
      createdAt
      updatedBy {
        id
        name
      }
    }
  }
`
export const DELETE_INVOICE = gql`
  mutation DELETE_INVOICE($invoice: ID!) {
    deleteInvoice(invoice: $invoice) {
      id
    }
  }
`
export const CANCEL_E_INVOICE = gql`
  mutation CANCEL_E_INVOICE($input: CancelEInvoiceInput!) {
    cancelEInvoice(input: $input) {
      success
      message
      data {
        id
        invoiceId
        status
        submissionTime
        clearanceTime
        errorMessages
      }
      errors {
        field
        message
      }
    }
  }
`

export const REPORT_PATIENT_E_INVOICE = gql`
  mutation REPORT_PATIENT_E_INVOICE($input: SubmitEInvoiceInput!) {
    reportPatientEInvoice(input: $input) {
      success
      message
      data {
        id
        invoiceId
        provider
        status
        attemptNumber
        submissionTime
        statusChangedAt
        transactionType
        infoMessages
        warningMessages
        errorMessages
      }
      errors {
        field
        message
      }
    }
  }
`

export const CANCEL_PATIENT_E_INVOICE = gql`
  mutation CANCEL_PATIENT_E_INVOICE($input: CancelEInvoiceInput!) {
    cancelPatientEInvoice(input: $input) {
      success
      message
      data {
        id
        invoiceId
        provider
        status
        attemptNumber
        submissionTime
        statusChangedAt
        transactionType
        infoMessages
        warningMessages
        errorMessages
      }
      errors {
        field
        message
      }
    }
  }
`

export const REPORT_INSURANCE_E_INVOICE = gql`
  mutation REPORT_INSURANCE_E_INVOICE($input: SubmitEInvoiceInput!) {
    reportInsuranceEInvoice(input: $input) {
      success
      message
      data {
        id
        invoiceId
        provider
        status
        attemptNumber
        submissionTime
        statusChangedAt
        transactionType
        infoMessages
        warningMessages
        errorMessages
      }
      errors {
        field
        message
      }
    }
  }
`

export const CANCEL_INSURANCE_E_INVOICE = gql`
  mutation CANCEL_INSURANCE_E_INVOICE($input: CancelEInvoiceInput!) {
    cancelInsuranceEInvoice(input: $input) {
      success
      message
      data {
        id
        invoiceId
        provider
        status
        attemptNumber
        submissionTime
        statusChangedAt
        transactionType
        infoMessages
        warningMessages
        errorMessages
      }
      errors {
        field
        message
      }
    }
  }
`

export const RELEASE_INVOICE = gql`
  mutation RELEASE_INVOICE($invoice: ID!) {
    releaseInvoice(invoice: $invoice) {
      id
      pendingPayment
      pendingPaymentPercent
      total
      released
      releasedAt
      paidInFull
      releasedBy {
        id
        name
      }
    }
  }
`
export const DELETE_PAYMENT = gql`
  mutation DELETE_PAYMENT($payment: ID!) {
    deletePayment(payment: $payment) {
      id
      invoice {
        id
        patient {
          id
          firstPaymentDate
          lastPaymentDate
          dailyAmountPaid
          insurancePaymentDate
          dailyInsurancePaid
          totalRemaining
          balance
          totalInsurance
          totalPaid
        }
      }
    }
  }
`
export const REFUND_PAYMENT = gql`
  mutation REFUND_PAYMENT($payment: ID!, $treasury: ID, $type: PaymentType, $refundedAmount: Float, $branch: ID!) {
    refundPayment(payment: $payment, treasury: $treasury, type: $type, refundedAmount: $refundedAmount, branch: $branch) {
      id
      amount
      invoice {
        id
        patient {
          id
          firstPaymentDate
          lastPaymentDate
          dailyAmountPaid
          insurancePaymentDate
          dailyInsurancePaid
          totalRemaining
          balance
          totalInsurance
          totalPaid
        }
      }
      refunded
      refundedAt
      refundedBy {
        id
        name
      }
    }
  }
`
export const EDIT_PAYMENT = gql`
  mutation EDIT_PAYMENT(
    $payment: ID!
    $type: PaymentType!
    $other: String
    $details: String
    $createdAt: DateTime
    $images: [String]
    $branch: ID!
    $doctor: ID!
    $treasury: ID
  ) {
    editPayment(
      payment: $payment
      type: $type
      other: $other
      details: $details
      createdAt: $createdAt
      images: $images
      branch: $branch
      doctor: $doctor
      treasury: $treasury
    ) {
      id
      type
      other
      claimed
      details
      images
      insuranceCompany {
        id
        name
      }
      branch {
        id
        name
      }
      doctor {
        id
        name
      }
      invoice {
        id
        patient {
          id
          firstPaymentDate
          lastPaymentDate
          dailyAmountPaid
          insurancePaymentDate
          dailyInsurancePaid
          totalRemaining
          balance
          totalInsurance
          totalPaid
        }
      }
      updatedAt
      createdAt
      updatedBy {
        id
        name
      }
    }
  }
`
export const UNGROUP_OPERATION = gql`
  mutation UNGROUP_OPERATION($operation: ID!) {
    ungroupOperation(operation: $operation)
  }
`
export const UPDATE_PENDING_PAYMENT = gql`
  mutation UPDATE_PENDING_PAYMENT($invoice: ID!, $pendingPayment: Float!, $pendingPaymentPercent: Float!) {
    updatePendingAmount(invoice: $invoice, pendingPayment: $pendingPayment, pendingPaymentPercent: $pendingPaymentPercent) {
      id
      pendingPayment
      pendingPaymentPercent
      updatedAt
      updatedBy {
        id
        name
      }
    }
  }
`
export const CREATE_NEW_NOTE = gql`
  mutation CREATE_NEW_NOTE(
    $generatedID: ID!
    $tooth: Int!
    $appointment: ID
    $patient: ID
    $doctor: ID
    $users: [ID]
    $child: Boolean!
    $details: String
    $url: String
    $procedure: ID
    $chart: ChartTypes
  ) {
    createNewNote(
      generatedID: $generatedID
      tooth: $tooth
      details: $details
      url: $url
      appointment: $appointment
      patient: $patient
      doctor: $doctor
      users: $users
      child: $child
      procedure: $procedure
      chart: $chart
    ) {
      id
      child
      tooth
      starred
      details
      url
      appointment {
        id
        start
        status
      }
      patient {
        id
        firstName
        lastName
      }
      leadStage {
        id
        name
      }
      doctor {
        id
        name
      }
      users {
        id
        name
      }
      createdBy {
        id
        name
      }
      updatedBy {
        id
        name
      }
      updatedAt
      createdAt
    }
  }
`
export const EDIT_NOTE = gql`
  mutation EDIT_NOTE($note: ID!, $details: String, $url: String, $patient: ID, $users: [ID]) {
    editNote(note: $note, details: $details, url: $url, patient: $patient, users: $users) {
      id
      details
      url
      updatedAt
      users {
        id
        name
      }
      patient {
        id
        firstName
        lastName
      }
      updatedBy {
        id
        name
      }
    }
  }
`
export const DELETE_NOTES = gql`
  mutation DELETE_NOTES($notes: [ID!]!) {
    deleteNotes(notes: $notes)
  }
`
export const UPDATE_NOTES_APPOINTMENT = gql`
  mutation UPDATE_NOTES_APPOINTMENT($notes: [ID!]!, $appointment: ID, $createdAt: DateTime, $doctor: ID) {
    updateNotesAppointment(notes: $notes, appointment: $appointment, createdAt: $createdAt, doctor: $doctor) {
      id
      appointment {
        id
        start
        status
        createdBy {
          id
          name
        }
      }
      updatedBy {
        id
        name
      }
      doctor {
        id
        name
      }
      createdAt
      updatedAt
    }
  }
`
export const CREATE_NEW_CANAL = gql`
  mutation CREATE_NEW_CANAL(
    $generatedID: ID!
    $tooth: Int!
    $appointment: String
    $patient: String!
    $doctor: String!
    $child: Boolean!
    $MB1: Float
    $MB2: Float
    $DB: Float
    $P: Float
    $L: Float
    $MB: Float
    $ML: Float
    $D: Float
    $B: Float
    $DL: Float
    $referencePoints: String
    $extraFields: String
    $procedure: ID
    $chart: ChartTypes
  ) {
    createNewCanal(
      generatedID: $generatedID
      tooth: $tooth
      MB1: $MB1
      MB2: $MB2
      DB: $DB
      P: $P
      L: $L
      MB: $MB
      ML: $ML
      D: $D
      B: $B
      DL: $DL
      appointment: $appointment
      patient: $patient
      doctor: $doctor
      child: $child
      referencePoints: $referencePoints
      extraFields: $extraFields
      procedure: $procedure
      chart: $chart
    ) {
      id
      child
      tooth
      MB1
      MB2
      DB
      P
      L
      MB
      ML
      D
      B
      DL
      referencePoints
      extraFields
      appointment {
        id
        start
        status
      }
      doctor {
        id
        name
      }
      createdBy {
        id
        name
      }
      updatedBy {
        id
        name
      }
      updatedAt
      createdAt
    }
  }
`
export const EDIT_CANAL = gql`
  mutation EDIT_CANAL(
    $canal: ID!
    $MB1: Float
    $MB2: Float
    $DB: Float
    $P: Float
    $L: Float
    $MB: Float
    $ML: Float
    $D: Float
    $B: Float
    $DL: Float
    $referencePoints: String
    $extraFields: String
  ) {
    editCanal(
      canal: $canal
      MB1: $MB1
      MB2: $MB2
      DB: $DB
      P: $P
      L: $L
      MB: $MB
      ML: $ML
      D: $D
      B: $B
      DL: $DL
      referencePoints: $referencePoints
      extraFields: $extraFields
    ) {
      id
      MB1
      MB2
      DB
      P
      L
      MB
      ML
      D
      B
      DL
      referencePoints
      extraFields
      updatedBy {
        id
        name
      }
    }
  }
`
export const DELETE_CANALS = gql`
  mutation DELETE_CANALS($canals: [ID!]!) {
    deleteCanals(canals: $canals)
  }
`
export const UPDATE_CANALS_APPOINTMENT = gql`
  mutation UPDATE_CANALS_APPOINTMENT($canals: [ID!]!, $appointment: ID, $createdAt: DateTime, $doctor: ID) {
    updateCanalsAppointment(canals: $canals, appointment: $appointment, createdAt: $createdAt, doctor: $doctor) {
      id
      appointment {
        id
        start
        status
        createdBy {
          id
          name
        }
      }
      doctor {
        id
        name
      }
      createdAt
      updatedBy {
        id
        name
      }
      updatedAt
    }
  }
`
export const CREATE_NEW_REMINDER_INSTANCE = gql`
  mutation CREATE_NEW_REMINDER_INSTANCE(
    $name: String
    $date: DateTime!
    $automatic: Boolean
    $details: String
    $patient: ID!
    $branch: ID!
    $types: [CommunicationTypes!]!
    $operation: ID
    $operationStep: ID
    $patientReminder: ID
  ) {
    createNewReminderInstance(
      name: $name
      date: $date
      automatic: $automatic
      details: $details
      patient: $patient
      branch: $branch
      types: $types
      operation: $operation
      operationStep: $operationStep
      patientReminder: $patientReminder
    ) {
      id
      createdAt
      date
      remindedAt
      name
      details
      automatic
      at
      types
      createdBy {
        id
        name
      }
      operation {
        id
        procedure {
          id
          code
          name
        }
      }
      patient {
        id
        firstName
        lastName
        phoneNumber
        title
        hasValidNumber
      }
      reminder {
        id
        name
        automatic
        details
        info
        at
      }
    }
  }
`
export const ADD_NEW_PAYMENT = gql`
  mutation ADD_NEW_PAYMENT(
    $generatedID: ID!
    $invoice: ID!
    $amount: Float!
    $type: PaymentType!
    $other: String
    $details: String
    $balance: Boolean
    $createdAt: DateTime
    $images: [String]
    $branch: ID!
    $treasury: ID
    $sms: Boolean
  ) {
    addNewPayment(
      generatedID: $generatedID
      invoice: $invoice
      amount: $amount
      type: $type
      other: $other
      details: $details
      balance: $balance
      createdAt: $createdAt
      images: $images
      branch: $branch
      treasury: $treasury
      sms: $sms
    ) {
      id
      amount
      balance
      type
      other
      claimed
      details
      images
      invoice {
        id
        paid
        paidInFull
        insurance
        pendingPaymentPercent
        pendingPayment
        patient {
          id
          totalInsurance
          totalPaid
          totalRemaining
          balance
          firstPaymentDate
          lastPaymentDate
          dailyAmountPaid
          insurancePaymentDate
          dailyInsurancePaid
        }
      }
    }
  }
`
export const ADD_NEW_PRESCRIPTION = gql`
  mutation ADD_NEW_PRESCRIPTION(
    $generatedID: ID!
    $details: String
    $name: String
    $branch: String!
    $users: [ID]
    $doctor: String
    $patient: String
    $medications: [MedicationInstanceInput!]!
    $appointment: ID
    $sms: Boolean
    $operation: ID
    $operationStep: ID
    $diagnosis: String
    $advice: String
    $followUpDate: DateTime
  ) {
    addNewPrescription(
      generatedID: $generatedID
      details: $details
      name: $name
      branch: $branch
      users: $users
      doctor: $doctor
      patient: $patient
      medications: $medications
      appointment: $appointment
      sms: $sms
      operation: $operation
      operationStep: $operationStep
      diagnosis: $diagnosis
      advice: $advice
      followUpDate: $followUpDate
    ) {
      id
      details
      name
      diagnosis
      advice
      followUpDate
      medication
      patient {
        id
        firstName
        lastName
        birthDate
        title
      }
      doctor {
        id
        name
      }
      users {
        id
        name
      }
      branch {
        id
        name
      }
      appointment {
        id
        start
        status
        end
      }
      createdAt
      createdBy {
        id
        name
      }
      updatedBy {
        id
        name
      }
      updatedAt
    }
  }
`
export const EDIT_PRESCRIPTION = gql`
  mutation EDIT_PRESCRIPTION(
    $prescription: ID!
    $details: String
    $name: String
    $medications: [MedicationInstanceInput!]!
    $appointment: ID
    $users: [ID]
    $diagnosis: String
    $advice: String
    $followUpDate: DateTime
  ) {
    editPrescription(
      prescription: $prescription
      details: $details
      name: $name
      medications: $medications
      appointment: $appointment
      users: $users
      diagnosis: $diagnosis
      advice: $advice
      followUpDate: $followUpDate
    ) {
      id
      details
      name
      diagnosis
      advice
      followUpDate
      medication
      appointment {
        id
        start
        status
        end
      }
      users {
        id
        name
      }
      createdAt
      updatedAt
      createdBy {
        id
        name
      }
      updatedBy {
        id
        name
      }
    }
  }
`
export const DELETE_PRESCRIPTION = gql`
  mutation DELETE_PRESCRIPTION($prescription: ID!) {
    deletePrescription(prescription: $prescription) {
      id
    }
  }
`
export const SAVE_PERIO_EXAM = gql`
  mutation SAVE_PERIO_EXAM($generatedID: ID!, $patient: ID, $perioExam: ID, $teethData: [TeethDataObject!]!) {
    savePerioExam(generatedID: $generatedID, patient: $patient, perioExam: $perioExam, teethData: $teethData)
  }
`
export const CONFIRM_PATIENT_DETAILS = gql`
  mutation CONFIRM_PATIENT_DETAILS($patient: ID!, $generatedID: ID) {
    confirmPatientDetails(patient: $patient, generatedID: $generatedID) {
      id
      hasMedicalAlerts
      pending
      medicalHistory {
        id
        status
        details
        options
        checkboxes
        medicalItemId
      }
      hasPendingMedical
      updatedAt
      createdBy {
        id
        name
      }
      updatedBy {
        id
        name
      }
    }
  }
`
export const SAVE_PATIENT_DETAILS = gql`
  mutation SAVE_PATIENT_DETAILS(
    $generatedID: ID!
    $appointment: ID!
    $forRegister: Boolean
    $firstName: String!
    $lastName: String!
    $address: String
    $email: String
    $birthDate: DateTime
    $birthDay: String
    $gender: String
    $marital: String
    $nationalId: String
    $nationality: String
    $patientTitle: String
    $phoneNumber: String!
    $phoneNumber2: String!
    $firstNameE: String
    $lastNameE: String
    $phoneNumberE: String
    $phoneNumber2E: String
    $referralDetails: String
    $addressE: String
    $relationE: String
    $country: String
    $state: String
    $longitude: Float
    $latitude: Float
    $patientDetails: String
    $job: String
    $medicalValues: [MedicalValuesInput!]!
    $insuranceEndDate: DateTime
    $referralSource: ID
    $referralSubSource: ID
    $insuranceNumber: String
    $insuranceGroup: String
    $insuranceCRT: String
  ) {
    savePatientDetails(
      generatedID: $generatedID
      appointment: $appointment
      forRegister: $forRegister
      firstName: $firstName
      lastName: $lastName
      address: $address
      email: $email
      birthDate: $birthDate
      birthDay: $birthDay
      gender: $gender
      marital: $marital
      nationalId: $nationalId
      nationality: $nationality
      patientTitle: $patientTitle
      phoneNumber: $phoneNumber
      phoneNumber2: $phoneNumber2
      firstNameE: $firstNameE
      lastNameE: $lastNameE
      phoneNumberE: $phoneNumberE
      phoneNumber2E: $phoneNumber2E
      referralDetails: $referralDetails
      addressE: $addressE
      relationE: $relationE
      country: $country
      state: $state
      longitude: $longitude
      latitude: $latitude
      patientDetails: $patientDetails
      job: $job
      medicalValues: $medicalValues
      insuranceEndDate: $insuranceEndDate
      referralSource: $referralSource
      referralSubSource: $referralSubSource
      insuranceNumber: $insuranceNumber
      insuranceGroup: $insuranceGroup
      insuranceCRT: $insuranceCRT
    ) {
      id
    }
  }
`

export const SAVE_MEDICAL_DETAILS = gql`
  mutation SAVE_MEDICAL_DETAILS($patient: ID!, $medicalValues: [MedicalValuesInput!]!) {
    saveMedicalDetails(patient: $patient, medicalValues: $medicalValues)
  }
`

export const CREATE_NEW_QUOTATION = gql`
  mutation CREATE_NEW_QUOTATION(
    $generatedID: ID!
    $total: Float!
    $tax: Float!
    $name: String
    $discount: Float!
    $insurance: Float!
    $subtotal: Float!
    $taxPercent: Float!
    $discountPercent: Float!
    $insurancePercent: Float
    $pendingPaymentPercent: Float
    $patientTaxPercent: Float
    $insuranceTaxPercent: Float
    $operations: [ID!]!
    $patient: ID!
    $users: [ID]
    $createdAt: DateTime
    $sms: Boolean
    $branch: ID!
    $doctor: ID!
    $details: String
    $diagnosis: String
    $hidePrices: Boolean
    $order: String
    $chart: ChartTypes!
    $operationInsurance: String
  ) {
    createNewQuotation(
      generatedID: $generatedID
      total: $total
      tax: $tax
      name: $name
      discount: $discount
      insurance: $insurance
      subtotal: $subtotal
      taxPercent: $taxPercent
      discountPercent: $discountPercent
      insurancePercent: $insurancePercent
      pendingPaymentPercent: $pendingPaymentPercent
      patientTaxPercent: $patientTaxPercent
      insuranceTaxPercent: $insuranceTaxPercent
      operations: $operations
      patient: $patient
      users: $users
      createdAt: $createdAt
      sms: $sms
      branch: $branch
      doctor: $doctor
      details: $details
      diagnosis: $diagnosis
      hidePrices: $hidePrices
      order: $order
      chart: $chart
      operationInsurance: $operationInsurance
    ) {
      id
      total
      tax
      name
      discount
      subtotal
      pendingPayment
      taxPercent
      discountPercent
      patientTaxPercent
      insuranceTaxPercent
      insurance
      operationInsurance
      pendingPaymentPercent
      details
      diagnosis
      hidePrices
      percentage
      order
      procedures {
        id
        amount
        tooth
        price
        child
        status
        approved
        approvalRequired
        toothPart
        procedure {
          id
          name
          code
          insuranceDiscount
          toothEffect
        }
        condition {
          id
          name
          code
          toothEffect
        }
        doctor {
          id
          name
        }
      }
      patient {
        id
        firstName
        lastName
        birthDate
        balance
        patientId
        referenceId
        phoneNumber
        insuranceCompany {
          id
          name
        }
        insuranceNumber
        insuranceCRT
        insuranceGroup
        insuranceLimit
        insurancePercentage
        insuranceEndDate
        insuranceUnlimited
        insured
        approvalRequired
      }
      branch {
        id
        name
      }
      doctor {
        id
        name
      }
      users {
        id
        name
      }
      createdAt
      updatedAt
      createdBy {
        id
        name
      }
      updatedBy {
        id
        name
      }
    }
  }
`
export const EDIT_QUOTATION = gql`
  mutation EDIT_QUOTATION(
    $quotation: ID!
    $total: Float!
    $tax: Float!
    $name: String
    $discount: Float!
    $insurance: Float!
    $subtotal: Float!
    $taxPercent: Float!
    $discountPercent: Float!
    $insurancePercent: Float
    $pendingPaymentPercent: Float
    $patientTaxPercent: Float
    $insuranceTaxPercent: Float
    $users: [ID]
    $createdAt: DateTime
    $branch: ID!
    $doctor: ID!
    $details: String
    $operations: [ID!]!
    $diagnosis: String
    $hidePrices: Boolean
    $order: String
    $operationInsurance: String
  ) {
    editQuotation(
      quotation: $quotation
      total: $total
      tax: $tax
      name: $name
      discount: $discount
      insurance: $insurance
      subtotal: $subtotal
      taxPercent: $taxPercent
      discountPercent: $discountPercent
      insurancePercent: $insurancePercent
      pendingPaymentPercent: $pendingPaymentPercent
      patientTaxPercent: $patientTaxPercent
      insuranceTaxPercent: $insuranceTaxPercent
      users: $users
      createdAt: $createdAt
      branch: $branch
      doctor: $doctor
      details: $details
      operations: $operations
      diagnosis: $diagnosis
      hidePrices: $hidePrices
      order: $order
      operationInsurance: $operationInsurance
    ) {
      id
      total
      tax
      name
      discount
      subtotal
      pendingPayment
      taxPercent
      discountPercent
      patientTaxPercent
      insuranceTaxPercent
      pendingPaymentPercent
      insurance
      operationInsurance
      details
      diagnosis
      hidePrices
      percentage
      order
      signed
      procedures {
        id
        amount
        tooth
        price
        child
        status
        approved
        approvalRequired
        toothPart
        procedure {
          id
          name
          code
          insuranceDiscount
          toothEffect
        }
        condition {
          id
          name
          code
          toothEffect
        }
        doctor {
          id
          name
        }
      }
      patient {
        id
        firstName
        lastName
        birthDate
        balance
        patientId
        referenceId
        phoneNumber
        insuranceCompany {
          id
          name
        }
        insuranceLimit
        insurancePercentage
        insuranceEndDate
        insuranceUnlimited
        insured
      }
      branch {
        id
        name
      }
      doctor {
        id
        name
      }
      users {
        id
        name
      }
      createdAt
      updatedAt
      createdBy {
        id
        name
      }
      updatedBy {
        id
        name
      }
    }
  }
`
export const DELETE_QUOTATION = gql`
  mutation DELETE_QUOTATION($quotation: ID!) {
    deleteQuotation(quotation: $quotation) {
      id
    }
  }
`
export const UPDATE_MIXED_DENTITION = gql`
  mutation UPDATE_MIXED_DENTITION($patient: ID!, $mixedDentition: [Int!]!) {
    updateMixedDentition(patient: $patient, mixedDentition: $mixedDentition) {
      id
      mixedDentition
    }
  }
`
export const GENERATE_NEW_PATIENT_LINK = gql`
  mutation GENERATE_NEW_PATIENT_LINK($branch: ID!) {
    generateNewPatientLink(branch: $branch)
  }
`
export const UPDATE_PATIENT_LINK = gql`
  mutation UPDATE_PATIENT_LINK(
    $patientLink: ID!
    $phoneNumber: String
    $name: String
    $expires: DateTime
    $limit: Int
    $hasMedical: Boolean
    $patientTag: ID
    $priceList: ID
  ) {
    updatePatientLink(
      patientLink: $patientLink
      phoneNumber: $phoneNumber
      name: $name
      expires: $expires
      limit: $limit
      patientTag: $patientTag
      priceList: $priceList
      hasMedical: $hasMedical
    ) {
      id
      name
      phoneNumber
      updatedAt
      expires
      hasMedical
      limit
      patientTag {
        id
        name
        color
      }
      priceList {
        id
        name
      }
      updatedBy {
        id
        name
      }
    }
  }
`
export const DELETE_PATIENT_LINK = gql`
  mutation DELETE_PATIENT_LINK($patientLink: ID!) {
    deletePatientLink(patientLink: $patientLink) {
      id
    }
  }
`
export const ADD_NEW_FREE_FORM_INSTANCE = gql`
  mutation ADD_NEW_FREE_FORM_INSTANCE(
    $name: String!
    $content: String
    $branch: ID!
    $users: [ID]
    $operations: [ID]
    $doctor: ID!
    $patient: ID!
    $appointment: ID
    $operationStep: ID
    $form: ID
    $signRequired: Boolean
    $sms: Boolean
    $expiresIn: DateTime
  ) {
    addNewFreeFormInstance(
      name: $name
      content: $content
      branch: $branch
      users: $users
      operations: $operations
      doctor: $doctor
      patient: $patient
      appointment: $appointment
      form: $form
      signRequired: $signRequired
      sms: $sms
      operationStep: $operationStep
      expiresIn: $expiresIn
    ) {
      id
      name
      content
      signed
      expiresIn
      signRequired
      signature
      patient {
        id
        firstName
        lastName
        phoneNumber
        title
        patientId
        referenceId
      }
      operations {
        id
        name
        code
        status
        child
        missing
        tooth
        createdAt
        doctor {
          id
          name
        }
      }
      appointment {
        id
        start
        end
        status
        room
      }
      branch {
        id
        name
      }
      users {
        id
        name
      }
      doctor {
        id
        name
      }
      branch {
        id
        name
      }
      signedAt
      signedBy {
        id
        name
      }
      createdAt
      createdBy {
        id
        name
      }
      updatedBy {
        id
        name
      }
      updatedAt
    }
  }
`
export const EDIT_FREE_FORM_INSTANCE = gql`
  mutation EDIT_FREE_FORM_INSTANCE(
    $formInstance: ID!
    $name: String!
    $content: String
    $branch: ID!
    $users: [ID]
    $operations: [ID]
    $doctor: ID!
    $patient: ID!
    $appointment: ID
    $form: ID
    $signRequired: Boolean
    $expiresIn: DateTime
  ) {
    editFreeFormInstance(
      formInstance: $formInstance
      name: $name
      content: $content
      branch: $branch
      users: $users
      operations: $operations
      doctor: $doctor
      patient: $patient
      appointment: $appointment
      form: $form
      signRequired: $signRequired
      expiresIn: $expiresIn
    ) {
      id
      name
      content
      signed
      signRequired
      signature
      expiresIn
      patient {
        id
        firstName
        lastName
        phoneNumber
        title
        patientId
        referenceId
      }
      operations {
        id
        name
        code
        status
        child
        missing
        tooth
        createdAt
        doctor {
          id
          name
        }
      }
      appointment {
        id
        start
        end
        status
        room
      }
      branch {
        id
        name
      }
      users {
        id
        name
      }
      doctor {
        id
        name
      }
      branch {
        id
        name
      }
      signedAt
      signedBy {
        id
        name
      }
      createdAt
      createdBy {
        id
        name
      }
      updatedBy {
        id
        name
      }
      updatedAt
    }
  }
`

export const CLEAR_FREE_FORM_INSTANCE_EXPIRATION = gql`
  mutation CLEAR_FREE_FORM_INSTANCE_EXPIRATION($formInstance: ID!) {
    clearFreeFormInstanceExpiration(formInstance: $formInstance) {
      id
      expiresIn
      updatedBy {
        id
        name
      }
      updatedAt
    }
  }
`
export const DELETE_FREE_FORM_INSTANCE = gql`
  mutation DELETE_FREE_FORM_INSTANCE($formInstance: ID!) {
    deleteFreeFormInstance(formInstance: $formInstance) {
      id
    }
  }
`

export const SIGN_FREE_FORM_INSTANCE = gql`
  mutation SIGN_FREE_FORM_INSTANCE(
    $formInstance: ID!
    $signature: String!
    $signatureID: String
    $signatureName: String
    $forWitness: Boolean
    $token: String
  ) {
    signFreeFormInstance(
      formInstance: $formInstance
      signature: $signature
      signatureID: $signatureID
      signatureName: $signatureName
      forWitness: $forWitness
      token: $token
    ) {
      id
      signed
      witnessSigned
      signature
      expiresIn
      signedAt
      signatureID
      signatureName
      witnessSign
      witnessID
      witnessName
      witnessSignAt
      patient {
        id
        formsSigned
      }
      signedBy {
        id
        name
      }
    }
  }
`

export const SIGN_AND_CREATE_FREE_FORM_INSTANCE = gql`
  mutation SIGN_AND_CREATE_FREE_FORM_INSTANCE(
    $form: ID!
    $patient: ID!
    $branch: ID!
    $signature: String!
    $signatureID: String
    $signatureName: String
  ) {
    signAndCreateFreeFormInstance(
      form: $form
      patient: $patient
      branch: $branch
      signature: $signature
      signatureID: $signatureID
      signatureName: $signatureName
    ) {
      id
      signed
      witnessSigned
      signature
      expiresIn
      signedAt
      signatureID
      signatureName
      witnessSign
      witnessID
      witnessName
      witnessSignAt
      patient {
        id
        formsSigned
      }
      signedBy {
        id
        name
      }
    }
  }
`

export const ADD_INVOICE_SIGNATURE = gql`
  mutation ADD_INVOICE_SIGNATURE($invoice: ID!, $signature: String!) {
    addInvoiceSignature(invoice: $invoice, signature: $signature) {
      id
      signed
      signature
      signedAt
      signedBy {
        id
        name
      }
    }
  }
`

export const ADD_QUOTATION_SIGNATURE = gql`
  mutation ADD_QUOTATION_SIGNATURE($quotation: ID!, $signature: String!) {
    addQuotationSignature(quotation: $quotation, signature: $signature) {
      id
      signed
      signature
      signedAt
      signedBy {
        id
        name
      }
    }
  }
`

export const ADD_CLINICAL_SIGNATURE = gql`
  mutation ADD_CLINICAL_SIGNATURE(
    $clinicalTest: ID!
    $signature: String!
    $signatureID: String
    $signatureName: String
    $forWitness: Boolean
  ) {
    addClinicalSignature(
      clinicalTest: $clinicalTest
      signature: $signature
      signatureID: $signatureID
      signatureName: $signatureName
      forWitness: $forWitness
    ) {
      id
      signed
      witnessSigned
      signature
      signedAt
      signatureID
      signatureName
      witnessSign
      witnessID
      witnessName
      witnessSignAt
      signedBy {
        id
        name
      }
    }
  }
`

export const ADD_MEDICAL_SIGNATURE = gql`
  mutation ADD_MEDICAL_SIGNATURE(
    $patient: ID!
    $signature: String!
    $signatureID: String
    $signatureName: String
    $forWitness: Boolean
  ) {
    addMedicalSignature(
      patient: $patient
      signature: $signature
      signatureID: $signatureID
      signatureName: $signatureName
      forWitness: $forWitness
    ) {
      id
      signed
      witnessSigned
      signature
      signedAt
      signatureID
      signatureName
      witnessSign
      witnessID
      witnessName
      witnessSignAt
      signedBy {
        id
        name
      }
    }
  }
`

export const ADD_PAYMENT_SIGNATURE = gql`
  mutation ADD_PAYMENT_SIGNATURE($payment: ID!, $signature: String!) {
    addPaymentSignature(payment: $payment, signature: $signature) {
      id
      signed
      signature
      signedAt
      signedBy {
        id
        name
      }
    }
  }
`

export const UPDATE_PATIENT_REFERENCE_ID = gql`
  mutation UPDATE_PATIENT_REFERENCE_ID($patient: ID!) {
    updatePatientReferenceId(patient: $patient) {
      id
      type
      referenceId
    }
  }
`

export const ADD_INVOICES_TO_CLAIM = gql`
  mutation AddInvoicesToClaim($claim: ID!, $invoiceIds: [ID!]!) {
    addInvoicesToClaim(claim: $claim, invoiceIds: $invoiceIds) {
      id
      totalInsuranceAmount
      invoiceCount
      invoices {
        id
        referenceId
        total
        insurance
        createdAt
        patient {
          id
          fullName
        }
      }
    }
  }
`

export const REMOVE_INVOICES_FROM_CLAIM = gql`
  mutation RemoveInvoicesFromClaim($claim: ID!, $invoiceIds: [ID!]!) {
    removeInvoicesFromClaim(claim: $claim, invoiceIds: $invoiceIds) {
      id
      totalInsuranceAmount
      invoiceCount
      invoices {
        id
        referenceId
        total
        insurance
        createdAt
        patient {
          id
          fullName
        }
      }
    }
  }
`
